<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
</template>

<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import NavigationDefault from '@/components/navigation-default';
import Content from '@dengl/common/components/content.vue';

const getThemeIndex = gql`
	query getThemeIndex($path: String) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/thema',
			'nl-BE': '/skigebieden/thema'
		}
	},
	components: { NavigationDefault },
	layout: 'default',
	asyncData({ _params, app, route }) {
		return app.$graphClient
			.query({
				query: getThemeIndex,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'areas-theme-index-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.ads({ navigation: { visible: true, type: 'spot' } });
				app.breadcrumbs({
					[app.i18n.t(`page.areas:heading`)]: {
						name: 'areas'
					},
					[data.contentpage.name]: {
						name: 'areas-theme'
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'areas-theme-index-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
